import { css } from '@sitebase/emotion';

// 1. Hack to hide unwanted horizontal scrollbars which pushes the scrollbars
//    out of view, in this case -100px but it can be anything.
// 2. Pushes the content back up with the same amount of pixels.
export var container = /*#__PURE__*/css('box-sizing:content-box !important;display:flex;height:inherit;margin-bottom:-20px;overflow-x:scroll;overflow-y:hidden;padding-bottom:20px;position:relative;width:100%;');

export var content = /*#__PURE__*/css('box-sizing:border-box !important;display:flex;flex-shrink:0;height:inherit;list-style-type:none;margin:0;padding:0;');

export var item = /*#__PURE__*/css('display:flex;flex:1 0 auto;height:100%;white-space:nowrap;');